import { actionTypes } from './actions';
import initialState from './initialState';

export default function AccountsAbroadReducer(state = initialState, action) {
  switch (action.type) {
    case actionTypes.REQUEST_START:
      return state.set('loading', true).set('error', null).set('data', null);

    case actionTypes.REQUEST_SUCCESS:
      return state.set('loading', false).set('data', action.payload);

    case actionTypes.REQUEST_FAILURE:
      return state.set('loading', false).set('error', action.error);

    case actionTypes.SET_TITLE:
      return state.set('data', setTitle(state.get('data'), action));

    case actionTypes.DELETE:
      return state.set('data', deleteAccount(state.get('data'), action));
    case actionTypes.REQUEST_START_SKIP_LOADING:
    default:
      return state;
  }
}

function setTitle(accounts = [], { payload: { accountId, title } }) {
  const account = accounts.find((account) => account.accountTypeCode === accountId);
  if (!account) {
    return accounts;
  }

  account.pseudonym = title;

  return [...accounts]; // create new array
}

function deleteAccount(accounts = [], { accountId }) {
  return accounts.filter((account) => account.accountTypeCode !== accountId);
}
